export default __webpack_public_path__ + "static/media/copyrightWhite.c666a841.svg";